<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: url('../../../assets/img/admin/iiot/dabeijing.png') no-repeat center center;
  background-size: 100% 100%;
  //background: rgb(18, 18, 18);
}

::v-deep .progress-green {
  .el-progress__text {
    color: #39f16d !important;
  }

  .el-progress-bar__outer {
    background-color: #515c69;
  }
}

::v-deep .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

::v-deep .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}
</style>

<template>
  <div style="display: inline;">
    <div class="bg" style="height: 100%;width: 100%;box-sizing: border-box;display: flex;flex-direction: column;">
      <div ref="header" style="padding: 24px 24px  16px  24px;flex-shrink: 0;">
        <div class="module-grid2" style="border-radius: 2px;width: 100%;display: flex;justify-content: space-between;align-items: center;">
          <div style="width: 340px;cursor: pointer;"><img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 162px;height: 35px;" src="../../../assets/img/admin/iiot/logo.png" /></div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            <span style="color:#78f0fd">{{ $t('模压成型智能装备') }}</span
            ><span style="color:white;margin-left: 12px;margin-right: 12px">{{ 'IIOT' }}</span
            ><span style="color:white;">{{ $t('pingtai') }}</span>
          </div>
          <div class="monitorQualityAnalysis" style="width: 340px;display: flex;justify-content: flex-end;align-items: center;">
            <p style="font-size: 16px;color:white;">
              {{ dayjs(store.state.currentTime).format('YYYY.MM.DD') + '/' }}
            </p>
            <!-- <p style="font-size: 16px;color:white;">{{dayjs(store.state.currentTime).weekday(-7) +"/"  }}</p> -->
            <p style="font-size: 16px;color:white;">{{ dayjs(store.state.currentTime).format('hh:mm:ss') }}</p>
          </div>
        </div>
      </div>
      <div class="line" style="padding: 0px 24px;display: flex;justify-content: space-between;align-items: center;">
        <div style="border:2px solid rgb(52, 62, 71);height: 12px;width: 12px;border-radius: 50%;display: flex;justify-content: center;align-items: center;">
          <div style="background: white;height: 4px;width: 4px;border-radius: 50%"></div>
        </div>
        <div style="flex:1;height: 1px;background: rgb(52, 62, 71)"></div>
        <div style="border:2px solid rgb(52, 62, 71);height: 12px;width: 12px;border-radius: 50%;display: flex;justify-content: center;align-items: center;">
          <div style="background: white;height: 4px;width: 4px;border-radius: 50%"></div>
        </div>
      </div>
      <div style="padding: 10px 24px 24px  24px;display: flex;flex: 1;">
        <div style="display: flex;flex-direction: column;height: 100%;">
          <div style="font-size: 24px;color:white;width: 100%;text-align: center">智能生产数据</div>
          <div style="display: flex;flex-direction: column;flex:1;width: 458px;background-color: rgba(23,102,138,0.13);padding:20px;margin-top: 10px;justify-content: space-between;">
            <div>
              <div>
                <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/pingtaikehushuju.png" />
              </div>
              <div style="width: 100%;display: flex;justify-content: center;margin-top: 8px;">
                <img style="width:408px;height: auto;" src="../../../assets/img/admin/iiot/tuliyi.png" />
              </div>
              <div ref="chart" style="height: 180px;">
                <div id="iiotCustomerChart" style="height: 100%;width:100%"></div>
              </div>
            </div>
            <div style="">
              <div>
                <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/shebeizhuangkuang.png" />
              </div>
              <div style="width: 100%;display: flex;justify-content: flex-end;margin-top: 8px;">
                <img style="width:311px;height: auto;" src="../../../assets/img/admin/iiot/tulier.png" />
              </div>
              <div v-for="(item, i) in ['zhusuji', 'yazhuji', 'xiangjiaoji']">
                <div style="display: flex;margin-top: 20px;margin-bottom: 10px;align-items: center;justify-content: space-between;">
                  <div style="width: 50px;color:white;">{{ ['注塑机', '压铸机', '橡胶机'][i] }}</div>
                  <div style="flex:1;margin-left: 10px;display: flex;">
                    <div style="width: 25%;display: flex;justify-content: center;align-items: center;height: 20px;border:1px solid rgba(22,200,197,1);background: rgba(22,200,197,0.5);color:white;">
                      {{ content.shebeizhuangkuang[item].jinnianchujishu }}
                    </div>
                    <div style="width: 25%;display: flex;justify-content: center;align-items: center;height: 20px;border:1px solid rgba(255,156,93,1);background: rgba(255,156,93,0.5);color:white">
                      {{ content.shebeizhuangkuang[item].lianwangtaishu }}
                    </div>
                    <div style="width: 25%;display: flex;justify-content: center;align-items: center;height: 20px;border:1px solid rgba(23,176,255,1);background: rgba(23,176,255,0.5);color:white">
                      {{ content.shebeizhuangkuang[item].zhengzaikaijishu }}
                    </div>
                    <div style="width: 25%;display: flex;justify-content: center;align-items: center;height: 20px;border:1px solid rgba(184,184,184,1);background: rgba(184,184,184,0.5);color:white">
                      {{ content.shebeizhuangkuang[item].lixianshu }}
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px;">
                <div>
                  <p style="color:white;font-size:16px">{{ $t('shangyuekaijilv') }}</p>
                  <div style="display: flex;margin-top: 20px;align-items: center;">
                    <img style="width:84px;height: auto;" src="../../../assets/img/admin/iiot/shangyuekaijilvtubiao.png" />
                    <div style="color:white;margin-left: 12px;">
                      <p>
                        {{ $t('equipment_type_zhusuji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.zhusuji.shangyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                      <p>
                        {{ $t('equipment_type_yazhuji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.yazhuji.shangyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                      <p>
                        {{ $t('equipment_type_xiangjiaoji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.xiangjiaoji.shangyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div>
                  <p style="color:white;font-size:16px">{{ $t('benyuekaijilv') }}</p>
                  <div style="display: flex;margin-top: 20px;align-items: center;">
                    <img style="width:84px;height: auto;" src="../../../assets/img/admin/iiot/benyuekaijilvtubiao.png" />
                    <div style="color:white;margin-left: 12px;">
                      <p>
                        {{ $t('equipment_type_zhusuji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.zhusuji.benyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                      <p>
                        {{ $t('equipment_type_yazhuji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.yazhuji.benyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                      <p>
                        {{ $t('equipment_type_xiangjiaoji') }}<span style="font-size: 18px;margin-left: 10px">{{ (content.shebeizhuangkuang.xiangjiaoji.benyuekaijilv * 100).toFixed(1) }}%</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="">
              <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/hangyeshebeikaijilv.png" />
              <div style="margin-top:10px;">
                <div style="">
                  <div style="display: flex;margin-top: 10px;margin-bottom: 10px;align-items: center;color:#00aeff;justify-content: space-between;">
                    <div style="flex:1">{{ '行业' }}</div>
                    <div style="width: 60px;margin-left: 10px;">{{ $t('jinnianchujishu') }}</div>
                    <div style="width: 74px;margin-left: 10px;">{{ $t('lianwangshebeizongshu') }}</div>
                    <div style="width: 60px;margin-left: 10px;">{{ $t('shangyuekaijilv') }}</div>
                    <div style="width: 60px;margin-left: 10px;">{{ $t('benyuekaijilv') }}</div>
                  </div>
                  <div v-for="(item, i) in content.hangyeshebeikaijilv">
                    <div style="display: flex;align-items: center;">
                      <div style="flex:1" :style="{ color: ['#ff4d4d', '#78f0fd', '#78f0fd', '#ffffff', '#ffffff'][i] }">
                        {{ 'NO.' + (i + 1) }}<span style="color:white;margin-left: 8px;">{{ item.hangye }}</span>
                      </div>
                      <div style="width: 60px;margin-left: 10px;color:white;text-align:center">
                        {{ item.jinnianchujishu }}
                      </div>
                      <div style="width: 74px;margin-left: 10px;color:white;text-align:center">
                        {{ item.lianwangshebeizongshu }}
                      </div>
                      <div style="width: 60px;margin-left: 10px;color:white;text-align:center">{{ (item.shangyuekaijilv * 100).toFixed(2) }}%</div>
                      <div style="width: 60px;margin-left: 10px;color:white;text-align:center">{{ (item.benyuekaijilv * 100).toFixed(2) }}%</div>
                    </div>
                    <hr size="1" style="color: rgb(52, 62, 71);border-style:dotted;width:100%;margin-top: 5px;margin-bottom: 5px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style="flex:1;height: 100%;display: flex;flex-direction: column">
          <div style="flex-shrink: 0;display: flex;justify-content: space-around;margin-top: 56px;height: 109px;">
            <div style="display: flex;justify-content: center;position: relative;">
              <img style="width:297px;height: auto;position: absolute;" src="../../../assets/img/admin/iiot/shebeilianwangtaishu.png" />
              <p style="font-size: 50px;color:#78f0fd;z-index: 1;margin-top: 40px;">
                {{ content.ditu.shebeilianwangtaishu }}
              </p>
            </div>
            <div style="display: flex;justify-content: center;position: relative;">
              <img style="width:297px;height: auto;position: absolute;" src="../../../assets/img/admin/iiot/pingtaixitongyonghuhuoyueshu.png" />
              <p style="font-size: 50px;color:#78f0fd;z-index: 1;margin-top: 40px;">
                {{ content.ditu.pingtaixitongyonghuhuoyueshu }}
              </p>
            </div>
          </div>
          <div style="flex:1;display: flex;align-items: center;padding: 20px 80px 0px 80px;">
            <div style="position: relative;display: inline-block;">
              <img style="width:100%;height: auto;z-index: 0;" src="../../../assets/img/admin/iiot/ditu.png" />
              <p style="font-size: 16px;font-weight: bold;position: absolute;color:#78f0fd;z-index: 1;right:7%;top:52.2%">
                {{ content.ditu.zhejiangsheng }}
              </p>

              <p style="font-size: 16px;font-weight: bold;position: absolute;color:#78f0fd;z-index: 1;right:22%;bottom:5.8%">
                {{ content.ditu.guangdongsheng }}
              </p>
            </div>
          </div>
        </div>
        <div style="display: flex;flex-direction: column;height: 100%;">
          <div style="font-size: 24px;color:white;width: 100%;text-align: center">{{ $t('zhinengfuwushujv') }}</div>
          <div style="display: flex;flex-direction: column;flex:1;width: 458px;background-color: rgba(23,102,138,0.13);padding:20px;margin-top: 10px;justify-content: space-between;">
            <div>
              <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/baoxiugongdanchulishuju.png" />
              <div style="display: flex;flex-flow: wrap;margin-top:30px">
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/baoxiuzongshu.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">
                    {{ content.baoxiugongdanchulishuju.baoxiuzongshu }}
                  </div>
                </div>
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/yichuli.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">
                    {{ content.baoxiugongdanchulishuju.yizhuli }}
                  </div>
                </div>
              </div>
              <div style="display: flex;flex-flow: wrap;margin-top: 40px;">
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/daichuli.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">
                    {{ content.baoxiugongdanchulishuju.daichuli }}
                  </div>
                </div>
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/bihuanlv.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">
                    {{ content.baoxiugongdanchulishuju.bihuanlv }}
                  </div>
                </div>
              </div>
            </div>
            <div style="">
              <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/pingjunxiangyingshijian.png" />
              <div style="display: flex;flex-flow: wrap;margin-top:30px">
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/shangyue.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">{{ content.pingjunxiangyingshijian.shangyue }}分钟</div>
                </div>
                <div style="display: flex;align-items: center;width:50%">
                  <img style="width:104px;height: auto;" src="../../../assets/img/admin/iiot/benyue.png" />
                  <div style="font-size: 26px;color:white;margin-left: 10px;">{{ content.pingjunxiangyingshijian.benyue }}分钟</div>
                </div>
              </div>
            </div>
            <div style="">
              <img style="width:421px;height: auto;" src="../../../assets/img/admin/iiot/fuwubiaobing.png" />
              <div style="margin-top:10px;">
                <div style="font-size: 14px;color:white;width: 100%;text-align: center;padding: 4px 0px;">
                  {{ $t('leijiwanchengbaoxiudanqianwuming') }}
                </div>
                <div style="">
                  <div v-for="(item, i) in content.fuwubiaobing" style="display: flex;margin-top: 10px;align-items: center;">
                    <div style="width: 90px;" :style="{ color: ['#ff4d4d', '#78f0fd', '#78f0fd', '#ffffff', '#ffffff'][i] }">
                      {{ 'NO.' + (i + 1) }}<span style="color:white;margin-left: 8px;">{{ item.hangye }}</span>
                    </div>
                    <div style="flex:1;height: 5px;background: #1b2638">
                      <div style="width: 60%;background-image: linear-gradient(to right, #2165a7, #4ca6c3);height: 5px;"></div>
                    </div>
                    <div style="width: 40px;color: #ffffff;margin-left: 8px;">{{ item.danshu }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'admin_iiot_index',
  components: {},

  data() {
    return {
      content: null,
      iiotCustomerChart: null,
      timer: null,
      chartHeight: 0,
      chartWidth: 0
    };
  },

  created() {
    this.utils.event_hub.$emit('TOGGLE_TABBAR', true);
    this.timer = setInterval(() => {
      this.getLocaiton();
    }, 10000);
    this.getLocaiton();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getLocaiton() {
      this.http.get('/web/report/page/locaiton_temp').then(response => {
        let content = response.data.rows[0].content;
        this.content = JSON.parse(content);
        let pingtaikehushuju = this.content.pingtaikehushuju;
        this.content.pingtaikehushuju.chart = {};
        this.content.pingtaikehushuju.chart.shengfens = pingtaikehushuju.map(item => {
          return item.shengfen;
        });
        this.content.pingtaikehushuju.chart.xitongkehushuliang = pingtaikehushuju.map(item => {
          return item.xitongkehushuliang;
        });
        this.content.pingtaikehushuju.chart.xitongzhanghaoshuliang = pingtaikehushuju.map(item => {
          return item.xitongzhanghaoshuliang;
        });
        this.content.pingtaikehushuju.chart.shangyuerijunhuoyueshu = pingtaikehushuju.map(item => {
          return item.shangyuerijunhuoyueshu;
        });
        this.content.pingtaikehushuju.chart.benyuerijunhuoyueshu = pingtaikehushuju.map(item => {
          return item.benyuerijunhuoyueshu;
        });

        if (!this.iiotCustomerChart) {
          setTimeout(() => {
            this.initChart();
          }, 100);

          setTimeout(() => {
            let options = this.iiotCustomerChart.getOption();
            options.xAxis.data = this.content.pingtaikehushuju.chart.shengfens;
            options.series[0].data = this.content.pingtaikehushuju.chart.xitongkehushuliang;
            options.series[1].data = this.content.pingtaikehushuju.chart.xitongzhanghaoshuliang;
            options.series[2].data = this.content.pingtaikehushuju.chart.shangyuerijunhuoyueshu;
            options.series[3].data = this.content.pingtaikehushuju.chart.benyuerijunhuoyueshu;
            this.iiotCustomerChart.setOption(options);
          }, 300);
        }
      });
    },

    initChart() {
      let option = {
        backgroundColor: null,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '8',
          top: '20',
          containLabel: true
        },
        legend: {
          show: false,
          left: 'center',
          top: '0%',
          textStyle: {
            color: '#909399',
            fontSize: 12
          },
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25
        },

        dataZoom: [
          {
            show: false,
            height: 8,
            xAxisIndex: [0],
            bottom: 0,
            start: 0,
            end: 80,

            textStyle: {
              color: 'transparent',
              fontSize: 12
            },
            fillerColor: '#f0f2f2',
            borderColor: 'transparent',
            backgroundColor: 'transparent',
            showDataShadow: false,
            brushSelect: false
          },
          {
            type: 'inside',
            disabled: true
          }
        ],
        xAxis: {
          show: true,
          type: 'category',
          name: '',
          nameLocation: 'end',
          nameTextStyle: {
            fontSize: 12
          },

          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              color: '#000',
              width: 1
            }
          },
          axisTick: {
            show: false,
            alignWithLabel: false,
            interval: 'auto',
            inside: true,
            length: 5,
            lineStyle: {
              type: 'solid',
              width: 1,
              color: '#909399'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: '#909399'
            }
          },
          axisLabel: {
            margin: 8,
            interval: 'auto',
            rotate: 0,
            fontSize: 12,
            color: '#C0C4CC'
          },
          data: this.content.pingtaikehushuju.chart.shengfens
        },
        yAxis: [
          {
            show: false,
            type: 'value',
            name: this.$t(''),
            // min: 0,
            // max: 100,
            // interval: 10,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            show: false,
            type: 'value',
            name: this.$t(''),
            // min: 0,
            // max: 100,
            // interval: 10,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            show: false
          },
          {
            show: false,
            type: 'value',
            name: this.$t(''),
            min: 0,
            nameTextStyle: {
              color: '#909399'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#909399'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}222 ',
              rotate: 0,
              textStyle: {
                color: '#C0C4CC'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed',
                color: '#606672'
              }
            }
          }
        ],

        series: [
          {
            name: this.$t('xitongkehushuliang'),
            type: 'bar',
            barWidth: 10,
            tooltip: {
              valueFormatter: function(value) {
                return value;
              }
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(22,200,197,1)'
                  },
                  {
                    offset: 1,
                    color: '#FFFFFF'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            label: {
              show: false,
              rotate: 0,
              color: 'rgba(22,200,197,1)',
              position: 'top',
              fontSize: 12,
              labelFormatter: '{data}'
            },
            data: this.content.pingtaikehushuju.chart.xitongkehushuliang
          },
          {
            name: this.$t('xitongzhanghaoshuliang'),
            type: 'bar',
            barWidth: 10,
            tooltip: {
              valueFormatter: function(value) {
                return value;
              }
            },
            itemStyle: {
              normal: {
                color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(23,176,255,1)'
                  },
                  {
                    offset: 1,
                    color: '#FFFFFF'
                  }
                ]),
                barBorderRadius: 6
              }
            },
            label: {
              show: false,
              rotate: 0,
              color: 'rgba(23,176,255,1)',
              position: 'top',
              fontSize: 12,
              labelFormatter: '{data}'
            },
            data: this.content.pingtaikehushuju.chart.xitongzhanghaoshuliang
          },
          {
            name: this.$t('shangyuerijunhuoyueshu'),
            type: 'line',
            yAxisIndex: 2,

            symbol: 'none',
            itemStyle: {
              color: 'rgba(255,156,93,1)'
              // normal: {
              // 	lineStyle: {
              // 		color: 'rgba(255,156,93,1)'
              // 	}
              // }
            },

            data: this.content.pingtaikehushuju.chart.shangyuerijunhuoyueshu
          },
          {
            name: this.$t('benyuerijunhuoyueshu'),
            type: 'line',
            yAxisIndex: 2,

            symbol: 'none',
            itemStyle: {
              color: 'rgba(222,126,146,1)'
              // normal: {
              // 	lineStyle: {
              // 		color: 'rgba(222,126,146,1)'
              // 	}
              // }
            },

            data: this.content.pingtaikehushuju.chart.benyuerijunhuoyueshu
          }
        ]
      };

      var chartDom = document.getElementById('iiotCustomerChart');
      this.iiotCustomerChart = this.echarts.init(chartDom);
      option && this.iiotCustomerChart.setOption(option);
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        // this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header
        // 	.offsetHeight - 34;
        // this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
        if (this.iiotCustomerChart) {
          this.iiotCustomerChart.resize();
        }
      }, 500);
    }
  }
};
</script>
